import React from 'react'
import { Check } from 'sutra/components/Icons'
import {
  OptionAccessory,
  OptionCheck,
  OptionLabel,
} from 'sutra/components/Select/select-styles'
import type {
  SelectOption,
  SelectValue,
} from 'sutra/components/Select/select-types'

interface OptionContentProps<O extends SelectOption<SelectValue>> {
  option: O
  optionRender?: (option: O) => React.ReactNode
  // `multiple`/`tags` rows end in a check while selected.
  withCheck?: boolean
}

// The inside of an option row, shared by every mode.
export function OptionContent<O extends SelectOption<SelectValue>>({
  option,
  optionRender,
  withCheck = false,
}: OptionContentProps<O>): React.ReactElement {
  return (
    <>
      <OptionLabel>
        {optionRender ? optionRender(option) : option.label}
      </OptionLabel>
      {option.accessory && (
        // A click on the accessory must not bubble to the option and commit it.
        <OptionAccessory
          className="option-accessory"
          onClick={(event) => event.stopPropagation()}
        >
          {option.accessory}
        </OptionAccessory>
      )}
      {withCheck && (
        <OptionCheck>
          <Check />
        </OptionCheck>
      )}
    </>
  )
}
